import { useBrandSettings } from '../stores/brand-settings';

export const parseBrandSettings = (brandSettings = {}) => {
    const brandSettingsStore = useBrandSettings();
    const typographyItems = [];
    const fonts = {};
    const googleIdentifier = [];
    const InheritingItems = [];

    const addTypographyItem = item => {
        if (item !== 'font' && typographyItems.includes(item) === false) {
            typographyItems.push(item);
        }
    };

    Object.entries(brandSettings).forEach(([key, value]) => {
        if (key.includes('colors')) {
            const color = key.replace('colors_global_', '').split('_')[0];
            const shade = key.replace('colors_global_', '').split('_')[1];

            document.documentElement.style.setProperty(shade ? `--global-${color}-${shade}` : `--global-${color}-color`, value);
            return;
        }

        if (key === 'socials') {
            if (!Array.isArray(value)) return;
            brandSettingsStore.socials.length = 0;
            value.forEach(social => {
                brandSettingsStore.addSocial(
                    social.brand_settings_socials_platform,
                    social.brand_settings_socials_url,
                );
            });
        }

        if (key.includes('typography')) {
            const setting = key.replace('typography_', '');

            if (setting.includes('font_family') && value !== 'inherit') {
                if (setting === 'font_family') {
                    fonts[setting] = [value];

                    document.documentElement.style.setProperty('--default-font-family', `"${value}"`);
                } else {
                    fonts[setting.split('_')[0]] = [value];
                }
            } else if (setting.includes('font_family') && value === 'inherit') {
                InheritingItems.push(setting.split('_')[0]);
            }

            if (setting.includes('font_weight') && Object.prototype.hasOwnProperty.call(fonts, setting.split('_')[0])) {
                fonts[setting.split('_')[0]].push(value);

                if (value === '300' || value === '400') {
                    fonts[setting.split('_')[0]].push(value + 'italic');
                }
            } else if (setting.includes('font_weight') && InheritingItems.includes(setting.split('_')[0])) {
                if (fonts['font_family'].indexOf(value) === -1) {
                    fonts['font_family'].push(value);

                    if (value === '300' || value === '400') {
                        fonts['font_family'].push(value + 'italic');
                    }
                }
            }

            addTypographyItem(setting.substr(0, setting.indexOf('_')));

            const replacements = {
                heading: number => `heading-${number}`,
                p: 'paragraph',
                tiny: 'tiny-text',
            };

            for (const item of typographyItems) {
                if (setting.includes(item)) {
                    const settingName = '--' + setting.replaceAll('_', '-')
                        .replace(/h(\d+)|\b(\w+)\b/g, (match, heading, word) => {
                            if (heading) return replacements.heading(heading);
                            return replacements[word] || match;
                        });

                    document.documentElement.style.setProperty(settingName, value);
                }
            }
        }
    });

    for (const [, value] of Object.entries(fonts)) {
        const fontName = value[0];
        const fontWeights = value.slice(1);

        if (!googleIdentifier.includes(`${fontName}:${fontWeights.join(',')}`)) {
            googleIdentifier.push(`${fontName}:${fontWeights.join(',')}`);
        }
    }

    import('webfontloader').then(WebFontLoader => {
        WebFontLoader.load({
            google: {
                families: googleIdentifier,
            },
        });
    });
};
